module.exports = __webpack_public_path__ + "img/module-three.399ef8e1.svg";